import { render } from "./PaginaQuestionarioWrapperWC.vue?vue&type=template&id=54dec919"
import script from "./PaginaQuestionarioWrapperWC.vue?vue&type=script&lang=js"
export * from "./PaginaQuestionarioWrapperWC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__